/* CLARESS · Test de rutina scrolleable
 * Sin dependencias. Un solo custom element <claress-rutina> que lee dos JSON
 * (config y productos) del propio markup y pinta todo lo demás.
 */
(() => {
  if (typeof customElements !== 'undefined' && customElements.get('claress-rutina')) return;

  const IVA = 0.16;

  const QUESTIONS = [
    {
      id: 'concerns', num: 1, label: 'Lo que quieres resolver', kicker: 'Pregunta 1 de 8', multi: true, max: 3,
      title: '¿Qué quieres resolver?',
      help: 'Marca hasta tres. La primera que marques es la principal: la rutina se ordena alrededor de ella y las demás entran sin chocar.',
      options: [
        ['spots', 'Manchas o melasma', 'En mejillas, bigote o frente. Las que no se van solas.'],
        ['acne', 'Brotes y marcas', 'Espinillas, brillo o las manchitas que dejan.'],
        ['dry', 'Resequedad y tirantez', 'Piel que pide crema y se descama.'],
        ['sensitive', 'Se me irrita todo', 'Rojeces, ardor o reacción con productos nuevos.'],
        ['aging', 'Líneas y firmeza', 'Textura irregular, primeras arrugas.'],
        ['eyes', 'Ojeras y bolsas', 'Ojo cansado, bolsas por la mañana.'],
        ['body', 'Manchas en el cuerpo', 'Axilas, cuello, codos, ingles o zona íntima.']
      ]
    },
    {
      id: 'skin', num: 2, label: 'Tu piel', kicker: 'Pregunta 2 de 8',
      title: 'Al final del día, ¿cómo está tu piel?',
      help: 'Esto separa grasa de resequedad y de deshidratación. No es lo mismo.',
      options: [
        ['oily', 'Brilla', 'Frente, nariz o mentón con grasa.'],
        ['combination', 'Depende de la zona', 'Zona T brillante, mejillas normales o secas.'],
        ['dry', 'Tirante', 'Se siente incómoda, pide crema.'],
        ['balanced', 'Cómoda', 'Ni grasa ni tirantez.'],
        ['unsure', 'No estoy segura', 'Que las otras respuestas decidan.']
      ]
    },
    {
      id: 'sensitivity', num: 3, label: 'Sensibilidad', kicker: 'Pregunta 3 de 8',
      title: '¿Se te irrita fácil?',
      help: 'Si la barrera está molesta, primero la calmamos y después sumamos activos.',
      options: [
        ['low', 'Casi nunca', 'Tolero bien lo nuevo.'],
        ['medium', 'A veces', 'Algún activo me pica o me pone roja.'],
        ['high', 'Con frecuencia', 'Ardor, rojez o descamación seguido.'],
        ['diagnosed', 'Tengo rosácea o dermatitis', 'Quiero algo especialmente suave.']
      ]
    },
    {
      id: 'actives', num: 4, label: 'Lo que usas hoy', kicker: 'Pregunta 4 de 8 · Compatibilidad', multi: true,
      title: '¿Qué estás usando ahora?',
      help: 'Para no duplicarte activos. Si ya usas retinol, no te mandamos otro.',
      options: [
        ['retinol', 'Retinol', 'O derivados de vitamina A.'],
        ['acids', 'Ácidos', 'Glicólico, salicílico, láctico…'],
        ['vitaminC', 'Vitamina C', 'Serum o crema antioxidante.'],
        ['acne', 'Tratamiento para acné', 'Peróxido de benzoilo, adapaleno u otro.'],
        ['none', 'Nada de eso', 'Solo jabón, o nada.']
      ]
    },
    {
      id: 'safety', num: 5, label: 'Seguridad', kicker: 'Pregunta 5 de 8 · Seguridad',
      title: '¿Alguna de estas aplica?',
      help: 'No es un diagnóstico y no guardamos la respuesta. Solo ajusta qué activos entran.',
      options: [
        ['none', 'Ninguna', ''],
        ['pregnant', 'Embarazo o lactancia', ''],
        ['young', 'Tengo menos de 20 años', '']
      ]
    },
    {
      id: 'makeup', num: 6, label: 'Maquillaje', kicker: 'Pregunta 6 de 8',
      title: '¿Te maquillas a diario?',
      help: 'Si sí, la noche empieza desmaquillando. Si no, con el limpiador basta.',
      options: [
        ['daily', 'Sí, casi todos los días', ''],
        ['sometimes', 'A veces', ''],
        ['no', 'No', '']
      ]
    },
    {
      id: 'plan', num: 7, label: 'Qué armar', kicker: 'Pregunta 7 de 8',
      title: '¿Qué quieres armar?',
      help: 'La mejor rutina no es la más larga: es la que sí vas a hacer todos los días.',
      options: [
        ['essential', 'Solo lo esencial', '3 pasos: limpiar, tratar, proteger.'],
        ['full', 'Toda la rutina', 'Hasta 5 pasos: limpiador, activos, hidratante y protector.'],
        ['max', 'Toda la rutina, completa', 'Hasta 7 pasos: con tónico, desmaquillante y noches alternas.'],
        ['actives', 'Solo los activos', 'Tónico, serums y protector. Ya tengo limpiador e hidratante.']
      ]
    },
    {
      id: 'doubt', num: 8, label: 'Lo que te frena', kicker: 'Pregunta 8 de 8 · La honesta', optional: true,
      title: '¿Qué te haría dudar?',
      help: 'Prefiero responderte ahora y no que lo descubras después de pagar.',
      options: [
        ['works', 'No sé si funciona', ''],
        ['price', 'El precio', ''],
        ['fit', 'No sé si es para mí', ''],
        ['delivery', 'Comprar online y que no llegue', '']
      ]
    }
  ];

  const REQUIRED = QUESTIONS.filter((q) => !q.optional).map((q) => q.id);

  const META = {
    mousse:       { short: 'Mousse de limpieza · niacinamida', why: 'Limpia sin resecar y controla el brillo.', freq: 'Mañana y noche', time: 'both', role: 'cleanser' },
    mousseUltra:  { short: 'Mousse ultra gentil · avena', why: 'Limpia suave, sin fragancia, para piel que se irrita.', freq: 'Mañana y noche', time: 'both', role: 'cleanser' },
    micelar:      { short: 'Agua micelar · ácido hialurónico', why: 'Limpia sin tirantez y deja la piel hidratada.', freq: 'Mañana y noche', time: 'both', role: 'cleanser' },
    desmaquillante: { short: 'Agua micelar · desmaquillante', why: 'Retira el maquillaje antes del limpiador. Sin frotar.', freq: 'Noche · antes de limpiar', time: 'pm', role: 'prep', catalog: 'micelar' },
    tonicoAstringente: { short: 'Tónico · ácido salicílico 2%', why: 'Destapa poros y controla el sebo. Solo de noche.', freq: 'Noche · 3 noches por semana', time: 'pm', role: 'toner' },
    tonicoUltraGentil: { short: 'Tónico ultra gentil · sin alcohol', why: 'Calma y refresca sin irritar.', freq: 'Mañana y noche', time: 'both', role: 'toner' },
    gel:          { short: 'Gel hidratante ligero', why: 'Hidrata ligero: no engrasa ni tapa poros.', freq: 'Mañana y noche', time: 'both', role: 'hydrator' },
    skinRecovery: { short: 'Serum reparador de barrera', why: 'Calma, hidrata y repara la barrera. Sin fragancia.', freq: 'Mañana y noche', time: 'both', role: 'hydrator' },
    sunique:      { short: 'Protector solar FPS 50+', why: 'No deja blanco ni se siente pesado. Sin esto, la mancha vuelve.', freq: 'Cada mañana', time: 'am', role: 'spf' },
    azebiome:     { short: 'Ácido azelaico + CutiBiome CLR', why: 'Brotes, rojeces y las marcas que dejan.', freq: 'Noche · empezar 3 noches por semana', time: 'pm', role: 'treatment' },
    vitamina:     { short: 'Vitamina C+E+F · antioxidante', why: 'De mañana: luminosidad y defensa contra la mancha nueva.', freq: 'Cada mañana', time: 'am', role: 'treatment' },
    pigment:      { short: 'Pigment Control · despigmentante', why: 'El que aclara la mancha: kójico + glicólico + niacinamida.', freq: 'Noche · noches alternas', time: 'pm', role: 'treatment' },
    retinol:      { short: 'Cápsulas de retinol', why: 'Textura y líneas con una dosis exacta cada noche.', freq: 'Noche · 2 a 3 noches por semana', time: 'pm', role: 'treatment' },
    cerablend:    { short: 'Cápsulas de ceramidas + péptidos', why: 'Nutre y da firmeza cuando la piel está seca.', freq: 'Noche', time: 'pm', role: 'treatment' },
    cremaCorporal: { short: 'Crema despigmentante corporal', why: 'Aclara la mancha en axilas, cuello, ingles y zona íntima externa.', freq: 'Noche · sobre la zona limpia, todos los días', time: 'pm', role: 'body' },
    eyes:         { short: 'Contorno de ojos roll-on · cafeína', why: 'Bolsas y ojeras, mañana y noche.', freq: 'Mañana y noche', time: 'both', role: 'treatment' }
  };

  const SHORT = { spots: 'Manchas', acne: 'Brotes', dry: 'Resequedad', sensitive: 'Calma', aging: 'Líneas', eyes: 'Ojeras', body: 'Cuerpo' };
  const SOLO = {
    spots: 'Manchas + luminosidad', acne: 'Brotes + marcas', dry: 'Resequedad + barrera',
    sensitive: 'Calma + barrera', aging: 'Líneas + firmeza', eyes: 'Contorno + prevención', body: 'Manchas en el cuerpo'
  };

  const INTRO = {
    spots: 'Un despigmentante de noche, antioxidante de mañana y protector todos los días. Sin el protector, la mancha vuelve.',
    acne: 'Ácido azelaico para los brotes y las marcas, hidratación que no tapa poros y protector que no brilla.',
    dry: 'Limpieza suave, un serum que repara la barrera y protector. Primero confort, después activos.',
    sensitive: 'Rutina corta a propósito: barrera y protector. Cuando la piel esté tranquila, sumamos.',
    aging: 'Retinol en cápsulas de noche, antioxidante de mañana y protector. Es la combinación que más se sostiene.',
    eyes: 'El roll-on con cafeína entra mañana y noche, dentro de una rutina base para que no sea un producto suelto.',
    body: 'La crema despigmentante va de noche sobre la zona limpia, todos los días. En el cuerpo la constancia pesa más que la cantidad.'
  };

  const DOUBT = {
    works: { t: 'Si no sé si funciona', p: 'Cada producto de tu rutina dice qué activo lleva y por qué entra. Y si a las 4 semanas no ves cambio, nos escribes: te decimos qué ajustar, no te mandamos otro producto.' },
    price: { t: 'Si es el precio', p: 'Con Cashea pagas una inicial y el resto en cuotas, sin intereses. Si eres nivel 4 o más, tu inicial baja. También puedes empezar solo con el paso principal.' },
    fit: { t: 'Si no sé si es para mí', p: 'Esta rutina se armó con tus respuestas, no con una lista genérica. Por WhatsApp te responde el equipo que formula, y si algo no encaja te lo decimos igual.' },
    delivery: { t: 'Si es que no llegue', p: 'Despachamos en 1 a 2 días hábiles por MRW o Zoom, con número de guía que puedes rastrear. En Caracas también hay entrega directa.' }
  };

  const SWAPS = {
    vitaminC: { from: 'tu vitamina C', id: 'vitamina', why: 'Vitamina C estabilizada (MAP) con vitamina E y ferulato, en envase airless: no se oxida ni se pone oscura como la mayoría. Si la tuya cambió de color, ya perdió potencia.' },
    retinol: { from: 'tu retinol', id: 'retinol', why: 'Retinol puro en cápsulas selladas: cada una es una dosis exacta y el activo no se degrada con el aire ni la luz. Menos margen de error, menos irritación por exceso.' },
    acne: { from: 'tu tratamiento para acné', id: 'azebiome', why: 'Ácido azelaico con CutiBiome CLR: trabaja el brote y la marca que deja, y es más suave que el peróxido de benzoilo o el adapaleno. Apto si la piel ya está irritada.' },
    acids: { from: 'tus ácidos', id: 'pigment', alt: 'tonicoAstringente', why: 'Si tu objetivo son manchas, Pigment Control combina glicólico con kójico y niacinamida: exfolia y aclara en el mismo paso. Si es grasa y poros, el Tónico Astringente con salicílico 2% va directo al poro.' }
  };

  const LABELS = Object.fromEntries(QUESTIONS.flatMap((q) => q.options.map(([v, t]) => [`${q.id}:${v}`, t])));

  const esc = (v = '') => String(v).replace(/[&<>'"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[c]));
  const money = (n) => `$${(Math.round(Number(n) * 100) / 100).toFixed(2).replace('.', ',')}`;

  class ClaressRutina extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.settings = this.readJSON('[data-crt-config]');
      this.catalog = this.readJSON('[data-crt-products]');
      this.storageKey = `claress-rutina-${this.settings.sectionId || 'main'}-v1`;
      this.attribution = Object.fromEntries([...new URLSearchParams(window.location.search)].filter(([k]) => k.startsWith('utm_')));
      this.state = this.loadState();
      this.root = this.querySelector('[data-crt-root]');
      this.bar = this.querySelector('[data-crt-bar]');
      this.progress = this.querySelector('[data-crt-progress]');
      this.live = this.querySelector('[data-crt-live]');
      this.addEventListener('click', (e) => this.onClick(e));
      this.addEventListener('input', (e) => this.onInput(e));
      this.render(true);
      this.observe();
    }

    readJSON(sel) {
      try { return JSON.parse(this.querySelector(sel)?.textContent || '{}'); } catch (e) { console.error('CLARESS rutina: JSON inválido', e); return {}; }
    }
    loadState() {
      const base = { answers: { actives: [] }, removed: [], added: [], name: '', city: '' };
      try {
        const s = JSON.parse(window.localStorage.getItem(this.storageKey));
        if (!s || typeof s !== 'object') return base;
        return { ...base, ...s, answers: { actives: [], ...(s.answers || {}) }, removed: Array.isArray(s.removed) ? s.removed : [], added: Array.isArray(s.added) ? s.added : [] };
      } catch (_) { return base; }
    }
    save() { try { window.localStorage.setItem(this.storageKey, JSON.stringify(this.state)); } catch (_) {} }
    track(event, detail = {}) {
      const payload = { event, ...detail, ...this.attribution };
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
      window.dispatchEvent(new CustomEvent(`claress:${event}`, { detail: payload }));
    }
    announce(msg) { if (this.live) this.live.textContent = msg; }

    answered(id) {
      const a = this.state.answers[id];
      return Array.isArray(a) ? a.length > 0 : Boolean(a);
    }
    complete() { return REQUIRED.every((id) => this.answered(id)); }
    firstUnanswered() { return QUESTIONS.find((q) => !q.optional && !this.answered(q.id)) || null; }

    onClick(e) {
      const el = e.target.closest('[data-action]');
      if (!el || !this.contains(el)) return;
      const a = el.dataset.action;
      if (a === 'start') this.scrollTo(`[data-q="${QUESTIONS[0].id}"]`, 'routine_quiz_started');
      if (a === 'answer') this.choose(el.dataset.q, el.dataset.value);
      if (a === 'next') this.advance(el.dataset.q);
      if (a === 'go-result') this.scrollTo('[data-crt-result]');
      if (a === 'go-next') { const q = this.firstUnanswered(); this.scrollTo(q ? `[data-q="${q.id}"]` : '[data-crt-result]'); }
      if (a === 'reset') this.reset();
      if (a === 'remove') this.remove(el.dataset.product);
      if (a === 'restore') this.restore(el.dataset.product);
      if (a === 'add') this.add(el.dataset.product);
      if (a === 'whatsapp') this.track('routine_checkout_whatsapp', this.metrics());
      if (a === 'cashea') this.track('routine_checkout_cashea', { ...this.metrics(), product_id: el.dataset.product || 'store' });
    }
    onInput(e) {
      const f = e.target.closest('[data-field]');
      if (!f) return;
      this.state[f.dataset.field] = f.value.slice(0, 60);
      this.save();
      this.refreshLinks();
    }
    choose(qid, value) {
      const q = QUESTIONS.find((x) => x.id === qid);
      if (!q) return;
      this.state.removed = [];
      this.state.added = [];
      if (!q.multi) this.state.answers[qid] = value;
      else {
        const cur = Array.isArray(this.state.answers[qid]) ? this.state.answers[qid] : [];
        if (value === 'none') this.state.answers[qid] = ['none'];
        else {
          const w = cur.filter((x) => x !== 'none');
          if (w.includes(value)) this.state.answers[qid] = w.filter((x) => x !== value);
          else if (q.max && w.length >= q.max) { this.announce(`Puedes marcar máximo ${q.max}. Quita una para cambiarla.`); return; }
          else this.state.answers[qid] = [...w, value];
        }
      }
      this.save();
      this.track('routine_question_answered', { question_id: qid, value });
      this.render();
      if (!q.multi) this.advance(qid);
    }
    advance(qid) {
      const i = QUESTIONS.findIndex((x) => x.id === qid);
      const next = QUESTIONS[i + 1];
      if (this.complete() && (!next || this.answered(next.id) || next.optional && i + 1 === QUESTIONS.length - 1 && this.answered(next.id))) {
        this.track('routine_quiz_completed', this.metrics());
      }
      window.setTimeout(() => this.scrollTo(next ? `[data-q="${next.id}"]` : '[data-crt-result]'), 260);
    }
    scrollTo(sel, evt) {
      const el = this.querySelector(sel);
      if (evt) this.track(evt);
      el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    reset() {
      this.state = { answers: { actives: [] }, removed: [], added: [], name: this.state.name, city: this.state.city };
      try { window.localStorage.removeItem(this.storageKey); } catch (_) {}
      this.render();
      window.setTimeout(() => this.scrollTo(`[data-q="${QUESTIONS[0].id}"]`), 40);
    }
    remove(id) {
      if (!this.state.removed.includes(id)) this.state.removed.push(id);
      this.save(); this.track('routine_product_removed', { product_id: id });
      this.render(); this.announce('Producto quitado. El total se actualizó.');
    }
    add(id) {
      if (!this.state.added.includes(id)) this.state.added.push(id);
      this.save(); this.track('routine_product_added', { product_id: id });
      this.render(); this.announce('Producto agregado. El total se actualizó.');
    }
    restore(id) {
      this.state.removed = this.state.removed.filter((x) => x !== id);
      this.save(); this.render();
    }

    product(key) {
      const meta = META[key] || {};
      const c = this.catalog[meta.catalog || key] || {};
      return { id: key, ...meta, ...c, name: c.name || key };
    }
    context() {
      const a = this.state.answers;
      const actives = new Set(a.actives || []);
      const intense = ['retinol', 'acids', 'acne'].filter((x) => actives.has(x));
      const concerns = this.concerns();
      const diagnosed = a.sensitivity === 'diagnosed';
      const barrier = diagnosed || a.sensitivity === 'high';
      const sensitive = barrier || concerns.includes('sensitive');
      const requiresReview = barrier || actives.has('acne') || intense.length > 1;
      const pregnant = a.safety === 'pregnant';
      const young = a.safety === 'young';
      let guidance = null;
      const swapToAze = sensitive && concerns.includes('acne') && actives.has('acne') && !actives.has('retinol') && !actives.has('acids');
      if (swapToAze) guidance = 'Como se te irrita y ya usas un tratamiento para acné, no le sumamos nada encima: te proponemos cambiarlo por AzeBiome, ácido azelaico más suave que el peróxido o el adapaleno. Empieza 2 noches por semana y deja el otro.';
      else if (diagnosed) guidance = 'Por la rosácea o dermatitis dejamos un solo activo suave (ácido azelaico, si aplica) y SkinRecovery+ para calmar. Antes de sumar otro, cuéntanos por WhatsApp cómo va la piel.';
      else if (a.sensitivity === 'high') guidance = 'Como se te irrita seguido, entra un solo activo suave y SkinRecovery+ para calmar. Un activo más fuerte entra después, y te decimos cuándo.';
      else if (pregnant) guidance = `Por el embarazo o lactancia no incluimos retinol ni despigmentantes con ácidos${concerns.includes('body') ? ', tampoco el corporal' : ''}. El ácido azelaico y la vitamina C sí se usan. Consúltalo igual con tu médico.`;
      else if (young) guidance = 'Antes de los 20 no hace falta retinol: la rutina trabaja prevención con antioxidante y protector.';
      else if (actives.has('acne')) guidance = 'Ya usas un tratamiento para acné, así que no te sumamos otro activo fuerte. Escríbenos para ordenar cómo alternarlos.';
      else if (intense.length > 1) guidance = 'Ya usas más de un activo intenso. No añadimos otro: mejor ordenamos tus noches por WhatsApp.';
      else if (actives.has('retinol') || actives.has('acids')) guidance = 'No te sumamos otro activo fuerte de noche. Deja noches de descanso y no mezcles retinol con ácidos la misma noche.';
      else if (actives.has('vitaminC')) guidance = 'Ya usas vitamina C, así que no la duplicamos. La rutina se concentra en barrera, tu objetivo y protector.';
      return { actives, diagnosed, barrier, sensitive, requiresReview, guidance, concerns, pregnant, young };
    }
    concerns() {
      const c = this.state.answers.concerns;
      return Array.isArray(c) && c.length ? c : [];
    }
    build() {
      const a = this.state.answers;
      const concerns = this.concerns().length ? this.concerns() : ['spots'];
      const principal = concerns[0];
      const plan = a.plan || 'full';
      const ctx = this.context();
      const has = (x) => ctx.actives.has(x);
      const dryish = a.skin === 'dry' || concerns.includes('dry');
      const oily = a.skin === 'oily' || a.skin === 'combination' || concerns.includes('acne');
      const intense = has('retinol') || has('acids') || has('acne');
      const max = { essential: 3, full: 5, max: 7, actives: 5 }[plan] || 5;
      const activesOnly = plan === 'actives';
      const gentleMode = ctx.sensitive;
      this.trimmed = [];

      const cleanser = activesOnly ? null : gentleMode ? 'mousseUltra' : dryish ? 'micelar' : 'mousse';
      const desmaq = !activesOnly && a.makeup === 'daily' && cleanser !== 'micelar' && max >= 5 ? 'desmaquillante' : null;

      let toner = null;
      if (max >= 7 || activesOnly) {
        if (gentleMode) toner = 'tonicoUltraGentil';
        else if (oily && !has('acids') && !ctx.pregnant) toner = 'tonicoAstringente';
      }

      const allowed = (k) => {
        if (k === 'retinol' && (ctx.pregnant || ctx.young || gentleMode)) return false;
        if (k === 'pigment' && (ctx.pregnant || gentleMode)) return false;
        return true;
      };
      const pmFor = { spots: 'pigment', acne: 'azebiome', aging: 'retinol' };
      const swapToAze = gentleMode && concerns.includes('acne') && has('acne') && !has('retinol') && !has('acids');
      const pm = swapToAze ? ['azebiome'] : intense ? [] : concerns.map((c) => pmFor[c]).filter((k) => k && allowed(k));
      const pmLimit = plan === 'essential' || gentleMode ? 1 : 2;
      const pmUsed = [...new Set(pm)].slice(0, pmLimit);
      const wantsAm = (concerns.includes('spots') || concerns.includes('aging') || (concerns.includes('acne') && !pmUsed.length && !gentleMode)) && !has('vitaminC');
      const am = wantsAm ? 'vitamina' : null;
      const eyes = concerns.includes('eyes') ? 'eyes' : null;
      const bodyCream = concerns.includes('body') && !ctx.pregnant ? 'cremaCorporal' : null;

      const needsRecovery = dryish || gentleMode || a.sensitivity === 'medium' || (intense && !pmUsed.length) || concerns.includes('sensitive');
      const hydrator = needsRecovery ? 'skinRecovery' : activesOnly ? null : 'gel';
      const extra = (dryish || (concerns.includes('aging') && !allowed('retinol'))) && max >= 5 && !ctx.young ? 'cerablend' : null;

      const mainOf = {
        spots: pmUsed.includes('pigment') ? 'pigment' : am || 'skinRecovery',
        acne: pmUsed.includes('azebiome') ? 'azebiome' : 'skinRecovery',
        aging: pmUsed.includes('retinol') ? 'retinol' : extra || am || 'skinRecovery',
        dry: 'skinRecovery', eyes: 'eyes', sensitive: 'skinRecovery', body: bodyCream || 'skinRecovery'
      };
      const main = mainOf[principal];
      this.mainId = main;

      const order = [desmaq, cleanser, toner, am, eyes, ...pmUsed, hydrator, extra, 'sunique', bodyCream].filter(Boolean);
      if (!order.includes(main)) order.splice(cleanser ? 1 : 0, 0, main);
      const seen = new Set();
      const list = order.filter((k) => !seen.has(k) && seen.add(k)).map((k) => this.product(k));

      const trimOrder = ['gel', 'desmaquillante', 'tonicoAstringente', 'tonicoUltraGentil', 'cerablend', 'vitamina', 'eyes', pmUsed[1], 'skinRecovery'].filter(Boolean);
      const fixed = new Set([cleanser, main, 'sunique', bodyCream, gentleMode ? 'skinRecovery' : null].filter(Boolean));
      const trimmed = [];
      const limit = max + (bodyCream ? 1 : 0);
      while (list.length > limit) {
        const idx = trimOrder.map((k) => list.findIndex((p) => p.id === k && !fixed.has(k))).find((i) => i > -1);
        if (idx === undefined) break;
        trimmed.push(list.splice(idx, 1)[0]);
      }
      (this.state.added || []).forEach((k) => { if (!list.some((p) => p.id === k)) { const t = trimmed.find((p) => p.id === k) || (META[k] ? this.product(k) : null); if (t) list.push(t); } });
      this.trimmed = trimmed.filter((p) => !(this.state.added || []).includes(p.id));
      const rank = (k) => (order.indexOf(k) > -1 ? order.indexOf(k) : order.indexOf('sunique') - 0.5);
      list.sort((x, y) => rank(x.id) - rank(y.id));

      const nightActives = list.filter((p) => ['pigment', 'azebiome', 'retinol'].includes(p.id));
      if (nightActives.length > 1) nightActives.forEach((p) => {
        const other = nightActives.find((o) => o.id !== p.id);
        p.freq = `Noche · alternar con ${other.name}`;
      });
      if (gentleMode) list.forEach((p) => { if (p.id === 'azebiome') p.freq = 'Noche · empezar 2 noches por semana'; });
      return list;
    }
    routine() { return this.build().filter((p) => !this.state.removed.includes(p.id)); }
    priceWithIva(p) { return p.ivaIncluded === false ? Number(p.price) * (1 + IVA) : Number(p.price); }
    totals() {
      const r = this.routine();
      const total = r.reduce((s, p) => s + this.priceWithIva(p), 0);
      const inicial = r.reduce((s, p) => s + (Number(p.inicial) || this.priceWithIva(p) * 0.4), 0);
      const free = Number(this.settings.freeShippingFrom || 50);
      return { total, inicial, freeShipping: total >= free, freeFrom: free, count: r.length };
    }
    title() {
      const c = this.concerns();
      if (!c.length) return 'Tu rutina base';
      if (c.length === 1) return SOLO[c[0]];
      return c.map((k, i) => (i ? SHORT[k].toLowerCase() : SHORT[k])).join(' + ');
    }
    intro() {
      const c = this.concerns();
      if (!c.length) return '';
      const base = INTRO[c[0]] || '';
      return c.length > 1 ? `${base} Lo demás entra sin chocar: nunca dos activos fuertes la misma noche.` : base;
    }
    metrics() {
      const t = this.totals();
      return { concerns: this.concerns().join(','), requires_review: this.context().requiresReview, product_count: t.count, total: Math.round(t.total * 100) / 100 };
    }

    swaps() {
      const actives = [...this.context().actives].filter((k) => SWAPS[k]);
      const inRoutine = new Set(this.routine().map((p) => p.id));
      const concerns = this.concerns();
      return actives.map((k) => {
        const sw = SWAPS[k];
        let id = sw.id;
        if (k === 'acids' && !concerns.includes('spots') && sw.alt) id = sw.alt;
        if (this.context().pregnant && ['retinol', 'pigment'].includes(id)) return null;
        if (inRoutine.has(id) || !this.catalog[id]) return null;
        return { from: sw.from, why: sw.why, product: this.product(id) };
      }).filter(Boolean);
    }

    whatsappUrl() {
      const r = this.routine(); const t = this.totals(); const a = this.state.answers; const ctx = this.context();
      const line = (id) => { const v = a[id]; if (!v || (Array.isArray(v) && !v.length)) return null; return Array.isArray(v) ? v.map((x) => LABELS[`${id}:${x}`]).join(', ') : LABELS[`${id}:${v}`]; };
      const who = this.state.name ? `Soy ${this.state.name.trim()}${this.state.city ? `, de ${this.state.city.trim()}` : ''}. ` : '';
      const msg = [
        `Hola CLARESS 🩷 ${who}Hice el test de rutina en la página.`,
        '',
        `Lo que quiero resolver: ${line('concerns') || '-'}`,
        `Mi piel: ${line('skin') || '-'} · Se irrita: ${line('sensitivity') || '-'}`,
        `Uso hoy: ${line('actives') || '-'}`,
        a.safety && a.safety !== 'none' ? `Aplica: ${line('safety')}` : null,
        `Maquillaje: ${line('makeup') || '-'} · Quiero armar: ${line('plan') || '-'}`,
        a.doubt ? `Lo que me frena: ${line('doubt')}` : null,
        '',
        `Mi rutina (${r.length} pasos): ${r.map((p) => p.name).join(', ')}`,
        ...(this.state.added || []).filter((k) => Object.values(SWAPS).some((sw) => sw.id === k || sw.alt === k)).map((k) => `Plan a futuro: cambiar ${Object.entries(SWAPS).find(([, sw]) => sw.id === k || sw.alt === k)[1].from} por ${this.product(k).name}`),
        `Total con IVA: ${money(t.total)}`,
        '',
        ctx.requiresReview ? 'La página me dice que conviene revisarla con ustedes antes de sumar activos. ¿Me ayudan?' : '¿Me la apartan? ¿Cómo pago y cuánto tarda en llegar?',
        Object.keys(this.attribution).length ? `(${Object.entries(this.attribution).map(([k, v]) => `${k}=${v}`).join(' ')})` : null
      ].filter((x) => x !== null).join('\n');
      return `https://wa.me/${String(this.settings.whatsapp || '').replace(/\D/g, '')}?text=${encodeURIComponent(msg)}`;
    }
    casheaUrl() {
      const r = this.routine();
      const main = r.find((p) => p.id === this.mainId) || r.find((p) => p.role === 'treatment') || r.find((p) => p.id === 'skinRecovery') || r[0];
      return (main && main.cashea) || this.settings.casheaStore || '#';
    }
    refreshLinks() {
      this.querySelectorAll('[data-crt-wa]').forEach((el) => { el.href = this.whatsappUrl(); });
    }

    render(first) {
      const y = window.scrollY;
      this.root.innerHTML = this.renderQuestions() + this.renderResult();
      this.renderBar();
      this.renderProgress();
      if (!first) window.scrollTo(0, y);
      this.reveal(!first);
    }
    renderQuestions() {
      return QUESTIONS.map((q, qi) => {
        const val = this.state.answers[q.id];
        const unlocked = qi === 0 || this.answered(QUESTIONS[qi - 1].id) || this.answered(q.id);
        const opts = q.options.map(([v, t, d], i) => {
          const sel = q.multi ? (val || []).includes(v) : val === v;
          const pos = q.multi && q.max ? (val || []).indexOf(v) : -1;
          const tag = pos === 0 ? '<i class="crt-opt__tag">Principal</i>' : pos > 0 ? `<i class="crt-opt__tag crt-opt__tag--n">${pos + 1}ª</i>` : '';
          return `<button class="crt-opt ${sel ? 'is-selected' : ''}" type="button" data-action="answer" data-q="${q.id}" data-value="${esc(v)}" role="${q.multi ? 'checkbox' : 'radio'}" aria-checked="${sel}" data-reveal style="--d:${i * 60}ms">
            <span class="crt-opt__num">${String(i + 1).padStart(2, '0')}${tag}</span>
            <span class="crt-opt__body"><strong>${esc(t)}</strong>${d ? `<small>${esc(d)}</small>` : ''}</span>
            <span class="crt-opt__check" aria-hidden="true"></span>
          </button>`;
        }).join('');
        return `<section class="crt-q ${unlocked ? '' : 'is-locked'} ${this.answered(q.id) ? 'is-answered' : ''}" data-q="${q.id}" id="pregunta-${q.num}" aria-labelledby="crt-q-${q.id}">
          <div class="crt-q__inner">
            <p class="crt-kicker" data-reveal>${esc(q.kicker)}</p>
            <h2 class="crt-q__title" id="crt-q-${q.id}" data-reveal style="--d:60ms">${esc(q.title)}</h2>
            <p class="crt-q__help" data-reveal style="--d:120ms">${esc(q.help)}</p>
            <div class="crt-opts ${q.options.length > 4 ? 'crt-opts--grid' : ''}" role="${q.multi ? 'group' : 'radiogroup'}" aria-label="${esc(q.title)}">${opts}</div>
            ${q.multi ? `<div class="crt-q__actions"><button class="crt-btn crt-btn--dark" type="button" data-action="next" data-q="${q.id}" ${this.answered(q.id) ? '' : 'disabled'}>Siguiente ↓</button><span class="crt-q__hint">${q.max ? `Marca hasta ${q.max}. Toca de nuevo para quitar.` : 'Puedes marcar varias.'}</span></div>` : ''}
            ${q.optional ? `<div class="crt-q__actions"><button class="crt-btn crt-btn--ghost" type="button" data-action="go-result">Saltar y ver mi rutina ↓</button></div>` : ''}
          </div>
        </section>`;
      }).join('');
    }
    renderResult() {
      const done = this.complete();
      const started = this.answered('concerns');
      const r = this.routine();
      const nightPair = r.filter((p) => ['pigment', 'azebiome', 'retinol'].includes(p.id)).length > 1;
      const ctx = this.context();
      const t = this.totals();
      const am = r.filter((p) => ['am', 'both'].includes(p.time));
      const pm = r.filter((p) => ['pm', 'both'].includes(p.time));
      const removed = this.build().filter((p) => this.state.removed.includes(p.id));
      const doubt = DOUBT[this.state.answers.doubt];
      const a = this.state.answers;
      const sum = (id) => { const v = a[id]; if (!v || (Array.isArray(v) && !v.length)) return '<em>Sin responder</em>'; return esc(Array.isArray(v) ? v.map((x) => LABELS[`${id}:${x}`]).join(', ') : LABELS[`${id}:${v}`]); };

      const card = (p, i) => `<article class="crt-card ${p.available === false ? 'is-out' : ''}" data-reveal style="--d:${i * 70}ms">
          <span class="crt-card__step">${String(i + 1).padStart(2, '0')}</span>
          <div class="crt-card__img"><img src="${esc(p.image || '')}" alt="${esc(p.name)}" loading="lazy" width="120" height="160"></div>
          <div class="crt-card__body">
            <p class="crt-card__short">${esc(p.short)}</p>
            <h4>${esc(p.name)}</h4>
            <p class="crt-card__why">${esc(p.why)}</p>
            <p class="crt-card__freq">${esc(p.freq)}</p>
          </div>
          <div class="crt-card__side">
            <strong>${money(this.priceWithIva(p))}</strong>
            <small>${p.ivaIncluded === false ? `${money(p.price)} + IVA` : 'IVA incluido'}${p.regular ? ` · antes ${money(p.regular)}` : ''}</small>
            ${p.cashea ? `<a href="${esc(p.cashea)}" target="_blank" rel="noopener" data-action="cashea" data-product="${p.id}">Ver en Cashea ↗</a>` : ''}
            <button type="button" data-action="remove" data-product="${p.id}" aria-label="Quitar ${esc(p.name)}">Quitar</button>
          </div>
        </article>`;

      const block = (label, items) => `<div class="crt-block">
          <div class="crt-block__head"><span class="crt-kicker">${label}</span><small>${items.length} ${items.length === 1 ? 'paso' : 'pasos'}</small></div>
          ${items.map(card).join('')}
        </div>`;

      return `<section class="crt-result ${started ? '' : 'is-empty'} ${done ? 'is-done' : ''}" data-crt-result id="tu-rutina">
        <div class="crt-result__inner">
          <p class="crt-kicker" data-reveal>${done ? 'Tu rutina' : started ? 'Tu rutina · se ajusta con tus respuestas' : 'Tu rutina'}</p>
          <h2 class="crt-result__title" data-reveal style="--d:60ms">${started ? `${esc(this.title())}<span>.</span>` : 'Responde arriba y aquí aparece<span>.</span>'}</h2>
          <p class="crt-result__intro" data-reveal style="--d:120ms">${started ? esc(this.intro()) : 'Ocho preguntas. Al final tienes tu rutina de mañana y noche, con precio, lista para mandarla por WhatsApp o pagarla en cuotas.'}</p>
          ${!done && started ? `<p class="crt-result__pending" data-reveal>Faltan respuestas: <button type="button" class="crt-link" data-action="go-next">seguir con la pregunta ${this.firstUnanswered()?.num} ↑</button></p>` : ''}

          ${started ? `
          <div class="crt-routine">
            ${block('Mañana', am)}
            ${block('Noche', pm)}
          </div>
          ${(this.trimmed || []).length ? `<p class="crt-removed">Quedó fuera por el límite de pasos: ${this.trimmed.map((p) => `<strong>${esc(p.name)}</strong> <button type="button" class="crt-link" data-action="add" data-product="${p.id}">agregar igual</button>`).join(' · ')}</p>` : ''}
          ${removed.length ? `<p class="crt-removed">Quitaste: ${removed.map((p) => `<button type="button" class="crt-link" data-action="restore" data-product="${p.id}">${esc(p.name)} (volver a poner)</button>`).join(' · ')}</p>` : ''}

          ${this.swaps().length ? `
          <section class="crt-future" data-reveal>
            <p class="crt-kicker">Plan a futuro</p>
            <h3>Cuando se te acabe lo que ya usas</h3>
            <p class="crt-future__intro">No te pedimos botar nada. Estás usando ${this.swaps().map((x) => x.from).join(' y ')}; cuando lo termines, esto es lo que encaja con tu rutina y por qué.</p>
            <div class="crt-future__grid">
              ${this.swaps().map((x) => `
                <article class="crt-future__card">
                  <img src="${esc(x.product.image || '')}" alt="${esc(x.product.name)}" loading="lazy" width="96" height="120">
                  <div>
                    <p class="crt-card__short">En vez de ${esc(x.from)}</p>
                    <h4>${esc(x.product.name)}</h4>
                    <p>${esc(x.why)}</p>
                    <div class="crt-future__foot">
                      <strong>${money(this.priceWithIva(x.product))}</strong>
                      <button type="button" class="crt-btn crt-btn--ghost crt-btn--sm" data-action="add" data-product="${x.product.id}">Sumarlo ya</button>
                      ${x.product.cashea ? `<a href="${esc(x.product.cashea)}" target="_blank" rel="noopener" data-action="cashea" data-product="${x.product.id}">Ver en Cashea ↗</a>` : ''}
                    </div>
                  </div>
                </article>`).join('')}
            </div>
          </section>` : ''}

          <div class="crt-notes">
            <div class="crt-note" data-reveal><span class="crt-kicker">Cómo se armó</span>
              <ul><li>Cada activo entra por un objetivo que marcaste; nada duplicado.</li><li>Barrera según tu nivel de sensibilidad y tu tipo de piel.</li><li>Protector solar todas las mañanas, sin excepción.</li></ul></div>
            ${ctx.guidance ? `<div class="crt-note ${ctx.requiresReview ? 'crt-note--review' : 'crt-note--adjust'}" data-reveal style="--d:60ms"><span class="crt-kicker">${ctx.requiresReview ? 'Mejor la revisamos juntas' : 'Ajuste'}</span><p>${esc(ctx.guidance)}</p></div>` : ''}
            ${nightPair ? `<div class="crt-note crt-note--adjust" data-reveal style="--d:90ms"><span class="crt-kicker">Dos activos de noche</span><p>Van en noches alternas: una noche uno, la siguiente el otro. Nunca los dos juntos, y si la piel se molesta, deja una noche solo con hidratante.</p></div>` : ''}
            ${doubt ? `<div class="crt-note crt-note--doubt" data-reveal style="--d:120ms"><span class="crt-kicker">${esc(doubt.t)}</span><p>${esc(doubt.p)}</p></div>` : ''}
          </div>

          <div class="crt-summary" data-reveal>
            <div class="crt-summary__answers">
              <span class="crt-kicker">Tu resumen</span>
              <dl>
                <dt>Quieres resolver</dt><dd>${sum('concerns')}</dd>
                <dt>Tu piel</dt><dd>${sum('skin')}</dd>
                <dt>Se irrita</dt><dd>${sum('sensitivity')}</dd>
                <dt>Usas hoy</dt><dd>${sum('actives')}</dd>
                <dt>Seguridad</dt><dd>${sum('safety')}</dd>
                <dt>Maquillaje</dt><dd>${sum('makeup')}</dd>
                <dt>Armar</dt><dd>${sum('plan')}</dd>
                <dt>Te frena</dt><dd>${sum('doubt')}</dd>
              </dl>
              <button type="button" class="crt-link" data-action="reset">Volver a responder</button>
            </div>
            <div class="crt-summary__pay">
              <div class="crt-total">
                <span>Total con IVA · ${t.count} ${t.count === 1 ? 'producto' : 'productos'}</span>
                <strong>${money(t.total)}</strong>
                <small>${t.freeShipping ? 'Envío gratis a toda Venezuela comprando directo.' : `Envío por MRW o Zoom. Gratis desde ${money(t.freeFrom)} comprando directo.`}</small>
                <small>Con Cashea: desde ${money(t.inicial)} de inicial, el resto en cuotas. La inicial depende de tu nivel${t.total >= 25 ? ', y con Cashea Envíos el envío va gratis' : ''}.</small>
              </div>
              <div class="crt-fields">
                <label><span>Tu nombre <em>(opcional)</em></span><input type="text" data-field="name" value="${esc(this.state.name)}" placeholder="Para que el mensaje salga con tu nombre" autocomplete="given-name" maxlength="60"></label>
                <label><span>Ciudad <em>(opcional)</em></span><input type="text" data-field="city" value="${esc(this.state.city)}" placeholder="Para calcular el envío" autocomplete="address-level2" maxlength="60"></label>
              </div>
              <a class="crt-btn crt-btn--wa" href="${esc(this.whatsappUrl())}" target="_blank" rel="noopener" data-action="whatsapp" data-crt-wa>${ctx.requiresReview ? 'Revisarla por WhatsApp' : 'Apartar mi rutina por WhatsApp'} →</a>
              <a class="crt-btn crt-btn--dark" href="${esc(this.casheaUrl())}" target="_blank" rel="noopener" data-action="cashea">Pagar en cuotas con Cashea →</a>
              <p class="crt-summary__fine">El mensaje va con tus respuestas y tu rutina ya escritas: nadie te vuelve a preguntar lo mismo. Cashea abre el producto principal; los demás los agregas desde la tienda CLARESS en la app. No hay monto mínimo, y desde $25 el envío sale gratis si eliges Cashea Envíos al pagar.</p>
            </div>
          </div>
          ` : ''}
          <p class="crt-legal">Esta guía es orientativa y no sustituye la evaluación de un profesional de salud. Suspende el uso si aparece irritación persistente.${this.settings.legal ? ` ${esc(this.settings.legal)}` : ''}</p>
        </div>
      </section>`;
    }
    renderBar() {
      if (!this.bar) return;
      const started = this.answered('concerns');
      const done = this.complete();
      const t = this.totals();
      this.bar.hidden = !started;
      if (!started) return;
      const q = this.firstUnanswered();
      this.bar.innerHTML = `<div class="crt-bar__inner">
        <div class="crt-bar__info"><strong>${esc(this.title())}</strong><span>${t.count} pasos · ${money(t.total)} con IVA${done ? '' : ` · falta la pregunta ${q?.num}`}</span></div>
        ${done
          ? `<a class="crt-btn crt-btn--wa crt-btn--sm" href="${esc(this.whatsappUrl())}" target="_blank" rel="noopener" data-action="whatsapp" data-crt-wa>Continuar por WhatsApp →</a>`
          : `<button class="crt-btn crt-btn--dark crt-btn--sm" type="button" data-action="go-next">Seguir ↓</button>`}
      </div>`;
    }
    renderProgress() {
      if (!this.progress) return;
      const n = QUESTIONS.filter((q) => this.answered(q.id)).length;
      this.progress.style.width = `${Math.round((n / QUESTIONS.length) * 100)}%`;
    }
    reveal(instant) {
      const els = this.querySelectorAll('[data-reveal]');
      if (instant) { els.forEach((el) => el.classList.add('is-in', 'is-instant')); return; }
      if (!this.io) return;
      els.forEach((el) => this.io.observe(el));
    }
    observe() {
      if (!('IntersectionObserver' in window)) { this.querySelectorAll('[data-reveal]').forEach((el) => el.classList.add('is-in')); return; }
      this.io = new IntersectionObserver((entries) => {
        entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); this.io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
      this.querySelectorAll('[data-reveal]').forEach((el) => this.io.observe(el));
    }
  }

  if (typeof customElements !== 'undefined') customElements.define('claress-rutina', ClaressRutina);
  if (typeof module !== 'undefined') module.exports = { ClaressRutina, QUESTIONS, META };
})();
